export function exclude(
	obj: { [prop: string]: string },
	excludeList: Array<string> = []
): { [prop: string]: string } {
	if (excludeList.length) {
		const newObj = { ...obj };
		excludeList.forEach((key: string): boolean => delete newObj[key]);
		return newObj;
	}

	return { ...obj };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/models/system-variables/helpers.ts